export enum EChatV2ServerPath {
  formSubmissionsLatest = '/chat/form-submissions/latest',
  conversationFormSubmissions = '/chat/conversations/:conversationId/form-submissions',
}

export type TPriorSubmission = {
  values: Record<string, unknown>
  submittedAt: string
}

export type TLatestFormSubmissionResponse = {
  priorSubmission: TPriorSubmission | null
}

export type TSubmitPreChatFormPayload = {
  formId: string
  values: Record<string, string>
}

// heyLibbyChat formSubmissionService.ts — single wire shape for POST 201,
// MESSAGE_NEW, and SESSION_READY history (details may be JSON string in cache).
export const CHAT_V2_FORM_SUBMISSION_MESSAGE_TYPE = 'form_submission'

export type TChatV2FormSubmissionFieldDetails = {
  label: string
  value: string
}

export type TChatV2FormSubmissionMessageDetails = {
  formId: string
  formSubmissionId: string
  formName: string
  fields: TChatV2FormSubmissionFieldDetails[]
}

export type TChatV2FormSubmissionWireMessage = {
  type: typeof CHAT_V2_FORM_SUBMISSION_MESSAGE_TYPE
  messageText: string
  details: TChatV2FormSubmissionMessageDetails
}

export type TSubmitPreChatFormResponse = {
  id: string
  message: TChatV2FormSubmissionWireMessage
}

export type TChatV2CachedHistoryMessage = {
  role?: string
  content?: string
  type?: string
  details?: string | TChatV2FormSubmissionMessageDetails
}

export type TChatV2MessageNewPayload = {
  role?: string
  content?: string
  type?: string
  details?: TChatV2FormSubmissionMessageDetails | string
  conversationId?: string
  contactId?: string | null
}
